<template>
    <div>

        <!-- FILTER START -->
        <panel class="border border-secondary" :noExpand="true">
            <template slot="header">
                <h4 class="panel-title">Filter Option</h4>
            </template>
            <div class="row outerBox filterBox">
                <div class="col row">
                    <div class="col-md-3 mobileFilterPaddingTop">
                        <label for="partshopCode">Range Date</label>
                        <flat-pickr
                            :config="rangePickr"
                            placeholder="Select Date"
                            v-model="selected.date"
                        ></flat-pickr>
                    </div>
                    <div class="col-md-3 mobileFilterPaddingTop">
                        <label for="partshopCode">Search Distance</label>
                        <input v-model="filter.distance" type="text" class="form-control" aria-label="Text input with dropdown button" style="height: 43px;" placeholder="Type Distance">
                    </div>
                    <div class="col-md-3 mobileFilterPaddingTop">
                        <label for="partshopCode">Variant</label>
                        <MultiSelect 
                            v-model="filter.variant"
                            :options="options.variant"
                            :deselect-label="''"
                            placeholder="All Variants"
                            class="elegant-multiselect"
                        />
                    </div>
                    <div class="col-md-3 mobileFilterPaddingTop">
                        <label for="partshopCode">Alasan Suspek</label>
                        <MultiSelect 
                            v-model="filter.reason"
                            :options="['Scan beda tempat','Scan lebih dari 5 kali']"
                            :deselect-label="''"
                            placeholder="All Alasan"
                            class="elegant-multiselect"
                        />
                    </div>
                    <div class="col-md-3 mobileFilterPaddingTop"
                        style="display: flex; flex-direction: column-reverse; padding-top:20px">
                        <button
                            type="button"
                            class="btn btn-primary"
                            style="height:38px; margin-bottom:0.5%"
                            @click="vue_universal_table.update++"
                        >Filter</button>
                    </div>
                </div>
            </div>
        </panel>
        <!-- FILTER END -->

        <!-- Table Start -->
        <div class="innerBox mt-4">
            <div class="mt-3">
                <vue-universal-table
                    api_url="/api/reports/suspect-report/table"
                    :filter="filter"
                    :fields="vue_universal_table.fields"
                    :buttons="vue_universal_table.buttons"
                    :update="vue_universal_table.update"
                    :process_data="vue_universal_table.process_data"

                    sort_order="DESC"
                    sort_by="scan_date"

                    @onViewDetail="seeDetail"
                ></vue-universal-table>
            </div>
        </div>
        <!-- Table End -->

        <!-- Modal Start -->
        <suspect-scan-map
            v-if="modal.map"
            :filter="modal.mapData"
            @closeModal="modal.map = false"
        ></suspect-scan-map>
        <!-- Modal End -->
        
    </div>
</template>

<script>
    import moment from 'moment';
    import customFilter from '@/components/filter/customFilter'
    
    import suspectScanMap from './children/suspectScanMap'

    export default {
        metaInfo : {
            title : 'Reports - Suspect'
        },
        data () {
            let startDate = moment().startOf('month').format("YYYY-MM-DD");
            let currentDate = moment().format("YYYY-MM-DD");

            return {
                modal : {
                    map : false,
                    mapData : null
                },
                rangePickr: {
                    mode: 'range',
                    dateFormat: "Y-m-d",
                    altInput: true,
                    altFormat: "d-m-Y",
                    altInputClass: 'form-control input elegant-flatpickr'
                },
                options : {
                    variant : this.$store.getters.getVariant,
                },
                selected : {
                    date : `${startDate} to ${currentDate}`
                },
                filter : {
                    start : startDate,
                    end : currentDate,
                    variant : null,
                    reason : null,
                    distance : null,
                    search : null,
                },
                vue_universal_table : {
                    fields : [
                        // {title:'URL', variable:'url', is_image: true},
                        {title:'Kode QR', variable:'qrcode'},
                        {title:'Variant', variable:'variant'},
                        // {title:'Volume', variable:'volume'},
                        {title:'Alasan', variable:'reason'},
                        {title:'Jumlah Scan', variable:'count', number_formatting:true},
                        {title:'Tanggal Scan', variable:'scan_date'},
                    ],
                    update : 0,
                    buttons : [
                        {
                            title:'viewDetail',
                            class:'fas fa-search btn-outline-info'
                        }
                    ],
                    process_data : `
                        for (var i in data) data[i].volume = (parseInt(data[i].volume))/1000 + ' Lt'

                        for (var i in data) {
                            data[i].qrcode = data[i].qrcode ? data[i].qrcode : '-'
                            data[i].variant = data[i].variant ? data[i].variant : '-'
                            data[i].reason = data[i].reason ? data[i].reason : '-'
                            data[i].scan_date = data[i].scan_date ? data[i].scan_date : '-'
                        }
                    `
                },
                tooltip : this.$store.state.tooltip.reports
            }
        },
        components : {
            customFilter,

            suspectScanMap,
        },
        watch : {
            'selected.date' () {
                let split = this.selected.date.split(" to ");
                this.filter.start = split[0];
                this.filter.end = split.length > 1 ? split[1] : split[0];
            }
        },
        methods : {
            seeDetail (row) {

                let  data = JSON.parse(row);

                this.modal.mapData = {
                    qrcode : data.qrcode,
                    start : this.filter.start,
                    end : this.filter.end,
                    reason : data.reason,
                    distance : this.filter.distance,
                };
                this.modal.map = true;
            },
            changeFilter (filter) {
                for (var i in filter) this.filter[i] = filter[i];
                // console.log(this.filter);
            }
        }
    }
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .table td, .table th{
        text-align: center;
    }
</style>